import { HStack, Stack, VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import { AccountPerformances } from '../AccountPerformances';
import { ConversionBigNumbers } from '../BigNumbers/components/ConversionBigNumbers';
import { CustomersActivation } from '../CustomersActivation';
import { CustomersActivationByProfile } from '../CustomersActivationByProfile';
import { InvestmentStrategy } from '../InvestmentStrategy';
import { LeadCaptureAndConversionProps } from '../LeadCaptureAndConversion';

export const Conversion: React.FC<LeadCaptureAndConversionProps> = ({ isMobile, isTablet }) => {
  const isDesktop = !isMobile && !isTablet;

  return (
    <VStack space={Spacing['stack.xxxs']}>
      <HStack px={Spacing['inline.xxxs']}>
        <VStack space={Spacing['stack.xxs']} pt={Spacing['stack.xxxs']} flex={1}>
          <ConversionBigNumbers isMobile={isMobile} isTablet={isTablet} />
          <AccountPerformances isMobile={isMobile} />
          {isMobile && <InvestmentStrategy isMobile={isMobile} />}
          <Stack
            space={Spacing[isDesktop ? 'inline.xxxs' : 'stack.xxs']}
            direction={isDesktop ? 'row' : 'column'}>
            <Stack {...(isDesktop ? { flex: 1 } : {})}>
              <CustomersActivation isMobile={isMobile} />
            </Stack>
            <Stack {...(isDesktop ? { flex: 1 } : {})}>
              <CustomersActivationByProfile isMobile={isMobile} />
            </Stack>
          </Stack>
          {!isMobile && <InvestmentStrategy isMobile={isMobile} />}
        </VStack>
      </HStack>
    </VStack>
  );
};
